import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

function Pagination({ page: nPage, total: nTotalPages, onChange }) {
  let nStartPage = nPage < 5 ? 1 : nPage - 3,
    nCount = nStartPage,
    nFinalPage = nTotalPages > 7 && nPage < 5 ? 7 : nPage + 3 < nTotalPages ? nPage + 3 : nTotalPages,
    aPages = [],
    // Rediseño: paginación compacta con bordes finos
    sItemClass =
      "inline-flex items-center justify-center h-8 min-w-[2rem] px-2 text-sm cursor-pointer text-gray-600 border border-line hover:bg-gray-50 hover:text-gray-800 dark:border-line-dark dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white ",
    sArrowClass =
      "inline-flex items-center justify-center h-8 px-2 cursor-pointer text-gray-500 bg-white border border-line hover:bg-gray-50 hover:text-gray-800 dark:bg-gray-800 dark:border-line-dark dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white";

  while (nCount <= nFinalPage) {
    if (nCount === nPage) aPages.push({ page: nCount, active: true });
    else aPages.push({ page: nCount, active: false });
    nCount++;
  }

  const bStartSection = nStartPage > 1,
    bFinishSection = nFinalPage < nTotalPages;

  return <nav aria-label="Paginación de listado">
    <ul className="inline-flex -space-x-px">
      {bStartSection && (
        <li>
          <span onClick={() => onChange(nPage - 1)} className={`${sArrowClass} rounded-l-md`}>
            <FiChevronLeft size="16" className="inline-block" />
          </span>
        </li>
      )}
      {aPages.map((oPage, nIndex) => (
        <li key={`page_${oPage.page}`}>
          <span
            onClick={() => onChange(oPage.page)}
            className={
              sItemClass +
              (nIndex === 0 && !bStartSection ? "ml-0 rounded-l-md " : "") +
              (nIndex === aPages.length - 1 && !bFinishSection ? "rounded-r-md " : "") +
              (oPage.active
                ? "relative z-10 font-medium bg-primary-50 text-primary-700 border-primary-200 dark:bg-gray-700 dark:text-white dark:border-gray-500"
                : "bg-white dark:bg-gray-800 ")
            }
          >
            {oPage.page}
          </span>
        </li>
      ))}
      {bFinishSection && (
        <li>
          <span onClick={() => onChange(nPage + 1)} className={`${sArrowClass} rounded-r-md`}>
            <FiChevronRight size="16" className="inline-block" />
          </span>
        </li>
      )}
    </ul>
  </nav>;
}

Pagination.displayName = "Table.Pagination";

export default Pagination;
